<template>
  <div class="class-list">
    <GlobalInfoBar title="线上订单" content="线上订单" />
    <!-- <Info/> -->
    <GlobalChunkNo icon="search" title="筛选查询">
      <div slot="filter">
        <From />
      </div>
      <Table />
    </GlobalChunkNo>
  </div>
</template>

<script>
import From from "./Form";
import Table from "./Table";
import _api from "@/utils/request";
export default {
  name: "class-list",
  components: {
    From,
    Table,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.class-list {
}
</style>